// @ts-nocheck
import React from "react";
import WinRateBar from "./WinRateBar";
import {byTournament} from "../data/fifaData";

// 4.2 Win rate by tournament (bar).

export default function WinRateByTournament() {
  const footnote = (
    <span className="fifa-legend">
      <span className="fifa-legend__note">
        One bar per World Cup (1994-2026). Dashed line = 50% coin flip. Hover for
        match count and draw rate. Draws count as a loss.
      </span>
    </span>
  );

  return (
    <WinRateBar
      title="Win rate by tournament"
      takeaway="Ranking predictiveness swings from a coin-flip 50% up to ~69% depending on the tournament."
      data={byTournament}
      indexBy="year"
      axisBottomLegend="World Cup"
      tooltipRows={datum => [
        {label: "Matches", value: datum.matches},
        {label: "Draw rate", value: `${datum.drawRate}%`}
      ]}
      footnote={footnote}
    />
  );
}
